import api from "../api";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Grid, Typography } from '@mui/material';
import AuthCard from './authCard';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const navigate = useNavigate();

    const handleResetPassword = async (event) => {
        event.preventDefault();
        setMessage('');
        setIsError(false);
        try {
            await api.post("/events/resetPassword", { userEmail: email });
            setMessage('Un mail de réinitialisation vous a été envoyé');
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (error) {
            // Le backend répond 404 quand l'adresse est inconnue : on affiche
            // son message plutôt que de laisser remonter le rejet d'axios.
            setIsError(true);
            setMessage(error.response?.data?.error || "Une erreur est survenue");
        }
    };

    return (
        <AuthCard>
            <Typography variant="h5" align="center" gutterBottom>
                Réinitialisation du mot de passe
            </Typography>
            <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
                Entrez votre adresse mail pour recevoir un lien de réinitialisation.
            </Typography>
            <form onSubmit={handleResetPassword}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" fullWidth>
                            Réinitialiser le mot de passe
                        </Button>
                    </Grid>
                </Grid>
            </form>
            {message && (
                <Typography
                    align="center"
                    color={isError ? "error" : "success.main"}
                    sx={{ mt: 2 }}
                >
                    {message}
                </Typography>
            )}
        </AuthCard>
    );
}

export default ForgotPassword;